import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import axios from 'axios';
import App from './App';
import consts from './main/consts'

class AuthOrApp extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    return false;
  }

  render() {
    const { auth } = this.props;
    axios.defaults.headers.common['Authorization'] = `Bearer ${auth.token}`;
    axios.defaults.headers.common['loja'] = auth.loja;
    axios.defaults.headers.common['maestro_version'] = consts.MAESTRO_MAIN_SOLUTION_VERSION;
    return <App>{this.props.children}</App>;
  }
}

const mapStateToProps = state => ({
  auth: state.auth
});
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);
export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(AuthOrApp);